import React from 'react';
import { Typography } from '@naf-simba/building-blocks-typography';
import * as S from './CompetitionHeader.styles';

interface CompetitionHeaderProps {
  title: string;
  ingress?: string;
  userEmail?: string;
  hasAnswered: boolean;
}

export const CompetitionHeader = ({ title, ingress, userEmail, hasAnswered }: CompetitionHeaderProps) => (
  <S.Header>
    {hasAnswered && (
      <S.Title>
        <Typography variant="textMItalic">Du har svart på denne konkurransen.</Typography>
      </S.Title>
    )}
    <S.Title>
      <Typography variant="headlineXS">{title}</Typography>
    </S.Title>
    {userEmail && <Typography variant="titleS">Logget inn som: {userEmail}</Typography>}
    {ingress && (
      <S.Ingress>
        <Typography variant="textMRegular">{ingress}</Typography>
      </S.Ingress>
    )}
  </S.Header>
);
